<template>
  <v-form>
    <gg-text-field
      label="Name"
      name="Name"
      placeholder="Valid zone name"
      v-model="model.name"
      v-validate="rules.name"
      :error-messages="errors.collect('Name')"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="TTL"
      name="TTL"
      placeholder="14400"
      v-model="model.ttl"
      v-validate="rules.ttl"
      :error-messages="errors.collect('TTL')"
      @input="sendData"></gg-text-field>
    <gg-input-label>
      Flag
      <v-tooltip bottom max-width="320">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="pb-1" small>mdi-information-outline</v-icon>
        </template>
        <span>{{ tooltip.flag }}</span>
      </v-tooltip>
    </gg-input-label>
    <v-radio-group v-model="model.flag" class="mt-1" row hide-details @change="sendData">
      <v-radio color="primary" label="0" value="0"></v-radio>
      <v-radio color="primary" label="1" value="1"></v-radio>
    </v-radio-group>
    <label class="mt-1">
      Tag
      <v-tooltip bottom max-width="320">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="pb-1" small>mdi-information-outline</v-icon>
        </template>
        <span>{{ tooltip.tag }}</span>
      </v-tooltip>
    </label>
    <v-radio-group v-model="model.tag" class="mt-1" row hide-details @change="sendData">
      <v-radio color="primary" label="issue" value="issue"></v-radio>
      <v-radio color="primary" label="issuewild" value="issuewild"></v-radio>
      <v-radio color="primary" label="iodef" value="iodef"></v-radio>
    </v-radio-group>
    <gg-text-field
      label="Value"
      name="Value"
      placeholder="Certificate Authority"
      :hint="tooltip.value"
      persistent-hint
      v-model="model.value"
      v-validate="rules.value"
      :error-messages="errors.collect('Value')"
      @input="sendData"></gg-text-field>
  </v-form>
</template>

<script>
import { ZoneRecord } from '@/mixins/ZoneRecord'

export default {
  name: 'CAARecordForm',
  mixins: [ZoneRecord],
  inject: ['parentValidator'],
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      model: {
        name: '',
        ttl: '14400',
        flag: '0',
        tag: 'issue',
        value: ''
      },
      rules: {
        name: { required: true },
        ttl: { required: true, numeric: true },
        value: { required: true, url: true }
      },
      tooltip: {
        flag: 'If “1”, the certificate issuer must understand the tag in order to correctly process the CAA record.',
        tag: 'The type of CAA record that this DNS entry represents. The issue and issuewild values represent the ' +
           'certificate authority’s domain name. The iodef value is the location to which the authority ' +
           'reports exceptions.',
        value: 'The certificate authority’s domain name.'
      }
    }
  },
  methods: {
    fillEditData () {
      for (let key in this.item) {
        if (this.item.hasOwnProperty(key)) {
          this.model[key] = this.item[key]
        }
      }
    }
  },
  created () {
    this.$validator = this.parentValidator
    // If props "edit" is true, it's mean that we use current component for edit a record, then execute next function
    if (this.edit) {
      this.fillEditData()
    }
    this.sendData()
  }
}
</script>
